(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xnerttek-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initXnProduct(section) {
      if (!section || section.dataset.xnProductInitialized === 'true') return;
      section.dataset.xnProductInitialized = 'true';
      var slides = section.querySelector('[data-xn-slides]');
      var slideItems = Array.prototype.slice.call(section.querySelectorAll('[data-xn-slide]'));
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-xn-thumb]'));
      var thumbRail = section.querySelector('.xn-product__thumbs');
      var total = section.querySelector('[data-xn-total]');
      var counter = section.querySelector('[data-xn-counter]');
      var prev = section.querySelector('[data-xn-prev]');
      var next = section.querySelector('[data-xn-next]');
      var variantInput = section.querySelector('[data-xn-variant-input]');
      var info = section.querySelector('.xn-product__info');
      var buybar = section.querySelector('.xn-product__buybar');
      var backTop = section.querySelector('[data-xn-back-top]');
      var progressRing = section.querySelector('[data-xn-progress-ring]');
      var progressRingLength = 1;
      var priceCard = section.querySelector('[data-xn-price-card]');
      var checkoutOptions = section.querySelector('[data-xn-checkout-options]');
      var exitModal = section.querySelector('[data-xn-exit-modal]');
      var exitConfirm = section.querySelector('[data-xn-exit-confirm]');
      var exitStay = section.querySelector('[data-xn-exit-stay]');
      var exitCouponCode = exitModal ? (exitModal.getAttribute('data-xn-exit-coupon-code') || '') : '';
      var exitShownStorageKey = 'xnProductExitCouponShown';
      var exitClaimStorageKey = 'xnProductExitCouponCode';
      var exitPopupShown = false;
      var exitBackPending = false;
      var exitHistoryReady = false;
      var variantData = [];
      var selectedOptions = [];
      var selectedPackageCount = 1;
      var selectedDiscountCode = '';
      var selectedItemOptions = [];

      // Default selected package comes from the theme editor. Fall back to the
      // first package that actually rendered (a configured default could be a
      // package whose label was left blank and therefore hidden).
      if (checkoutOptions) {
        var configuredDefault = parseInt(checkoutOptions.getAttribute('data-xn-default-package'), 10);
        var packageButtons = checkoutOptions.querySelectorAll('[data-xn-checkout-package-list] [data-package-count]');
        var availableCounts = Array.prototype.map.call(packageButtons, function (btn) {
          return Number(btn.getAttribute('data-package-count')) || 1;
        });
        if (availableCounts.indexOf(configuredDefault) !== -1) {
          selectedPackageCount = configuredDefault;
        } else if (availableCounts.length) {
          selectedPackageCount = availableCounts[0];
        }
      }

      if (checkoutOptions) {
        var variantJson = checkoutOptions.querySelector('[data-xn-variants-json]');
        if (variantJson) {
          try {
            variantData = JSON.parse(variantJson.textContent);
          } catch (error) {
            variantData = [];
          }
        }
      }

      if (total) total.textContent = String(Math.max(slideItems.length, 1));

      if (progressRing && typeof progressRing.getTotalLength === 'function') {
        try {
          progressRingLength = progressRing.getTotalLength();
          progressRing.style.strokeDasharray = String(progressRingLength);
          progressRing.style.strokeDashoffset = String(progressRingLength);
        } catch (error) {
          progressRingLength = 1;
        }
      }

      function updateBuybarHeight() {
        if (!buybar) return;
        section.style.setProperty('--xn-buybar-height', Math.ceil(buybar.getBoundingClientRect().height) + 'px');
        if (window.matchMedia('(min-width: 990px)').matches) {
          var infoRect = info ? info.getBoundingClientRect() : null;
          if (infoRect) {
            section.style.setProperty('--xn-buybar-left', Math.round(infoRect.left) + 'px');
            section.style.setProperty('--xn-buybar-width', Math.round(infoRect.width) + 'px');
          }
        } else {
          section.style.removeProperty('--xn-buybar-left');
          section.style.removeProperty('--xn-buybar-width');
        }
      }

      function updateBuybarStop() {
        if (!buybar) return;
        updateBuybarHeight();
        var sectionRect = section.getBoundingClientRect();
        var maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
        var progress = Math.min(Math.max(window.scrollY / maxScroll, 0), 1);
        if (progress > 0.985) progress = 1;
        section.classList.toggle('is-buybar-stopped', sectionRect.bottom <= window.innerHeight);
        section.classList.toggle('is-back-top-visible', window.scrollY > Math.max(window.innerHeight * 0.6, 360));
        if (progressRing) progressRing.style.strokeDashoffset = String((1 - progress) * progressRingLength);
      }

      updateBuybarStop();
      window.addEventListener('scroll', updateBuybarStop, { passive: true });
      window.addEventListener('resize', updateBuybarStop);

      if (backTop) {
        backTop.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }

      function showExitModal(isBackNavigation) {
        if (!exitModal || exitPopupShown) return false;
        try {
          if (window.localStorage.getItem(exitShownStorageKey) === 'true') return false;
        } catch (error) {}
        exitPopupShown = true;
        exitBackPending = Boolean(isBackNavigation);
        try {
          window.localStorage.setItem(exitShownStorageKey, 'true');
        } catch (error) {}
        exitModal.classList.add('is-visible');
        exitModal.setAttribute('aria-hidden', 'false');
        return true;
      }

      function hideExitModal() {
        if (!exitModal) return;
        exitBackPending = false;
        exitModal.classList.remove('is-visible');
        exitModal.setAttribute('aria-hidden', 'true');
      }

      function claimExitCoupon() {
        if (!exitCouponCode) return;
        selectedDiscountCode = exitCouponCode;
        try {
          window.localStorage.setItem(exitClaimStorageKey, exitCouponCode);
        } catch (error) {}
      }

      function getClaimedExitCoupon() {
        try {
          return window.localStorage.getItem(exitClaimStorageKey) || '';
        } catch (error) {
          return '';
        }
      }

      if (exitModal) {
        window.history.replaceState({ xnProductExit: true }, '', window.location.href);
        window.history.pushState({ xnProductExitGuard: true }, '', window.location.href);
        exitHistoryReady = true;

        window.addEventListener('popstate', function () {
          if (!exitHistoryReady) return;
          if (showExitModal(true)) {
            window.history.pushState({ xnProductExitGuard: true }, '', window.location.href);
          }
        });

        if (exitStay) {
          exitStay.addEventListener('click', function () {
            claimExitCoupon();
            hideExitModal();
          });
        }

        if (exitConfirm) {
          exitConfirm.addEventListener('click', function () {
            exitModal.classList.remove('is-visible');
            exitModal.setAttribute('aria-hidden', 'true');
            if (exitBackPending) {
              exitHistoryReady = false;
              window.history.back();
            }
          });
        }

        exitModal.addEventListener('click', function (event) {
          if (event.target === exitModal) hideExitModal();
        });
      }

      function setActiveSlide(index) {
        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.classList.toggle('is-active', thumbIndex === index);
        });
        if (counter) counter.firstChild.nodeValue = String(index + 1) + ' / ';
        updateGalleryHeight(index);
      }

      // Emulate Swiper autoHeight on mobile: size the slides track to the current
      // slide so shorter slides don't leave a blank gap. Only active below 990px;
      // on desktop the height is cleared so the existing layout is untouched.
      function updateGalleryHeight(index) {
        if (!slides) return;
        if (!window.matchMedia('(max-width: 989px)').matches) {
          slides.style.height = '';
          return;
        }
        var activeSlide = slideItems[index] || slideItems[0];
        if (!activeSlide) return;
        slides.style.height = activeSlide.offsetHeight + 'px';
      }

      function ensureItemOptions() {
        if (!selectedOptions.length && variantData[0] && Array.isArray(variantData[0].options)) {
          selectedOptions = variantData[0].options.slice();
        }

        for (var index = 0; index < 4; index += 1) {
          if (!Array.isArray(selectedItemOptions[index])) {
            selectedItemOptions[index] = selectedOptions.slice();
          }
        }
      }

      function packagesAreVariants() {
        return checkoutOptions && checkoutOptions.getAttribute('data-xn-packages-are-variants') === 'true';
      }

      function perBagColorMode() {
        return checkoutOptions && checkoutOptions.getAttribute('data-xn-per-bag-color') === 'true';
      }

      function getCheckoutQuantity() {
        return packagesAreVariants() ? 1 : selectedPackageCount;
      }

      function activePackageButton() {
        return checkoutOptions && checkoutOptions.querySelector('[data-xn-checkout-package-list] [data-package-count="' + selectedPackageCount + '"]');
      }

      function currentPackageOptionValue() {
        var button = activePackageButton();
        return button ? button.getAttribute('data-option-value') : null;
      }

      function packageOptionPosition() {
        var first = section.querySelector('[data-xn-checkout-package-list] [data-package-count]');
        return Number(first && first.getAttribute('data-option-position')) || 1;
      }

      function baseColorOrder() {
        var order = [];
        var buttons = section.querySelectorAll('[data-xn-checkout-item][data-item-index="0"] [data-option-position="0"][data-option-value]');
        Array.prototype.forEach.call(buttons, function (button) {
          var value = button.getAttribute('data-option-value');
          if (order.indexOf(value) === -1) order.push(value);
        });
        return order;
      }

      function comboLabelForSlots() {
        var colors = [];
        for (var index = 0; index < selectedPackageCount; index += 1) {
          colors.push((selectedItemOptions[index] || selectedOptions)[0]);
        }
        if (!colors.length) return null;
        var allSame = colors.every(function (color) { return color === colors[0]; });
        if (allSame) return colors[0];
        var counts = {};
        colors.forEach(function (color) { counts[color] = (counts[color] || 0) + 1; });
        var parts = baseColorOrder().filter(function (color) { return counts[color]; }).map(function (color) {
          return counts[color] === 1 ? color : color + ' ×' + counts[color];
        });
        return parts.join(' + ');
      }

      function resolvePerBagBundleVariant() {
        ensureItemOptions();
        var pkgValue = currentPackageOptionValue();
        var pkgPosition = packageOptionPosition();
        for (var index = 0; index < selectedPackageCount; index += 1) {
          if (!Array.isArray(selectedItemOptions[index])) {
            selectedItemOptions[index] = selectedOptions.slice();
          }
          if (pkgValue !== null) selectedItemOptions[index][pkgPosition] = pkgValue;
        }
        var comboLabel = comboLabelForSlots();
        var variant = null;
        variantData.forEach(function (candidate) {
          if (!variant && candidate.options[pkgPosition] === pkgValue &&
              candidate.options[0] === comboLabel && candidate.available !== false) {
            variant = candidate;
          }
        });
        if (variant) {
          selectedOptions = variant.options.slice();
          if (variantInput) variantInput.value = variant.id;
        }
        updateCheckoutOptionUi();
        return variant;
      }

      function setVariantFromPackage(packageButton) {
        if (!packageButton) return false;
        if (perBagColorMode()) {
          return Boolean(resolvePerBagBundleVariant());
        }
        var optionPosition = packageButton.getAttribute('data-option-position');
        var optionValue = packageButton.getAttribute('data-option-value');
        return optionPosition !== null
          && optionValue !== null
          && optionValue !== ''
          && Boolean(setVariantFromOption(Number(optionPosition) || 0, optionValue, null, 0));
      }

      function setActivePackageCount(count) {
        selectedPackageCount = Math.min(Math.max(Number(count) || 1, 1), 4);
        ensureItemOptions();
        var showSingleSkuSelector = (checkoutOptions && checkoutOptions.getAttribute('data-xn-single-sku-selector') === 'true') || packagesAreVariants();
        section.querySelectorAll('[data-xn-checkout-package-list] [data-package-count]').forEach(function (packageButton) {
          var isActivePackage = Number(packageButton.getAttribute('data-package-count')) === selectedPackageCount;
          packageButton.classList.toggle('is-active', isActivePackage);
          if (isActivePackage) {
            var discountCode = packageButton.getAttribute('data-discount-code') || '';
            try {
              selectedDiscountCode = discountCode ? JSON.parse(discountCode) : '';
            } catch (error) {
              selectedDiscountCode = discountCode;
            }
            syncPriceBarFromPackage(packageButton);
          }
        });
        section.querySelectorAll('[data-xn-checkout-item]').forEach(function (item) {
          var itemIndex = Number(item.getAttribute('data-item-index')) || 0;
          var visible = perBagColorMode() ? itemIndex < selectedPackageCount
            : (showSingleSkuSelector ? itemIndex === 0 : itemIndex < selectedPackageCount);
          item.classList.toggle('is-active', visible);
        });
        if (perBagColorMode()) resolvePerBagBundleVariant();
        updateCheckoutBuyState();
      }

      function syncPriceBarFromPackage(packageButton) {
        if (!priceCard || !packageButton) return;
        var currentPrice = priceCard.querySelector('[data-xn-price-current]');
        var comparePrice = priceCard.querySelector('[data-xn-price-compare]');
        var discountLabel = priceCard.querySelector('[data-xn-price-discount]');
        var nextPrice = packageButton.getAttribute('data-package-price');
        var nextCompare = packageButton.getAttribute('data-package-compare');
        var nextDiscount = packageButton.getAttribute('data-package-discount-label');

        if (currentPrice && packageButton.hasAttribute('data-package-price')) currentPrice.textContent = nextPrice || '';
        if (comparePrice && packageButton.hasAttribute('data-package-compare')) comparePrice.textContent = nextCompare || '';
        if (discountLabel && packageButton.hasAttribute('data-package-discount-label')) discountLabel.textContent = nextDiscount || '';
      }

      function updateCheckoutOptionUi() {
        ensureItemOptions();
        section.querySelectorAll('.xn-product__checkout-value[data-option-position]').forEach(function (optionButton) {
          var itemIndex = Number(optionButton.getAttribute('data-item-index')) || 0;
          var position = Number(optionButton.getAttribute('data-option-position')) || 0;
          var options = selectedItemOptions[itemIndex] || selectedOptions;
          optionButton.classList.toggle('is-active', optionButton.getAttribute('data-option-value') === options[position]);
        });

        section.querySelectorAll('[data-xn-option-label]').forEach(function (label) {
          var itemIndex = Number(label.getAttribute('data-item-index')) || 0;
          var position = Number(label.getAttribute('data-xn-option-label')) || 0;
          var options = selectedItemOptions[itemIndex] || selectedOptions;
          label.textContent = options[position] || '';
        });
      }

      function scrollToSlide(index) {
        if (!slides || !slideItems[index]) return;
        var previousScrollBehavior = slides.style.scrollBehavior;
        slides.style.scrollBehavior = 'auto';
        slides.scrollLeft = slideItems[index].offsetLeft;
        setActiveSlide(index);
        window.requestAnimationFrame(function () {
          slides.style.scrollBehavior = previousScrollBehavior;
        });
      }

      function scrollThumbRail(direction) {
        if (!thumbRail) return;
        var firstThumb = thumbs[0];
        var railStyles = window.getComputedStyle(thumbRail);
        var gap = parseFloat(railStyles.columnGap || railStyles.gap) || 0;
        var thumbWidth = firstThumb ? firstThumb.getBoundingClientRect().width : 86;
        var step = thumbWidth + gap;
        thumbRail.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          scrollToSlide(Number(thumb.getAttribute('data-xn-thumb')) || 0);
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          scrollThumbRail(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scrollThumbRail(1);
        });
      }

      function currentSlideIndex() {
        if (!slides) return 0;
        return Math.min(Math.max(Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1)), 0), slideItems.length - 1);
      }

      if (slides) {
        slides.addEventListener('scroll', function () {
          setActiveSlide(currentSlideIndex());
        }, { passive: true });

        // Recalculate on resize and once each slide image has loaded, since lazy
        // images report no height until they are decoded.
        window.addEventListener('resize', function () {
          updateGalleryHeight(currentSlideIndex());
        });
        slideItems.forEach(function (slide) {
          slide.querySelectorAll('img').forEach(function (img) {
            if (img.complete) return;
            img.addEventListener('load', function () {
              updateGalleryHeight(currentSlideIndex());
            });
          });
        });
        updateGalleryHeight(0);
      }

      // Auto-rotate the gallery. Interval (seconds) is set in the theme editor via
      // the gallery block; 0 disables it. Pauses on user interaction and when the
      // tab is hidden, then resumes.
      var autoplaySeconds = slides ? parseFloat(slides.getAttribute('data-xn-autoplay')) : 0;
      if (!(autoplaySeconds > 0)) autoplaySeconds = 0;
      var autoplayTimer = null;
      var autoplayResumeTimer = null;

      function advanceSlide() {
        if (!slides || slideItems.length < 2) return;
        var nextIndex = currentSlideIndex() + 1;
        if (nextIndex >= slideItems.length) {
          scrollToSlide(0);
        } else {
          slides.scrollTo({ left: slideItems[nextIndex].offsetLeft, behavior: 'smooth' });
          setActiveSlide(nextIndex);
        }
      }

      function startAutoplay() {
        if (!autoplaySeconds || slideItems.length < 2) return;
        stopAutoplay();
        autoplayTimer = window.setInterval(advanceSlide, autoplaySeconds * 1000);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function pauseAutoplayTemporarily() {
        if (!autoplaySeconds) return;
        stopAutoplay();
        if (autoplayResumeTimer) window.clearTimeout(autoplayResumeTimer);
        autoplayResumeTimer = window.setTimeout(startAutoplay, autoplaySeconds * 1000);
      }

      if (autoplaySeconds && slides) {
        slides.addEventListener('touchstart', pauseAutoplayTemporarily, { passive: true });
        slides.addEventListener('mousedown', pauseAutoplayTemporarily);
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', pauseAutoplayTemporarily);
        });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        });
        startAutoplay();
      }

      function setVariantSelection(variant) {
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;
        selectedOptions = Array.isArray(variant.options) ? variant.options.slice() : [];
        ensureItemOptions();
        selectedItemOptions[0] = selectedOptions.slice();
        section.querySelectorAll('.xn-product__buy-button').forEach(function (button) {
          button.disabled = variant.available === false;
        });

        setActivePackageCount(selectedPackageCount);
        updateCheckoutOptionUi();
        updateCheckoutBuyState();
      }

      function findVariantById(id) {
        return variantData.find(function (variant) {
          return String(variant.id) === String(id);
        });
      }

      function findVariantByOptions(options) {
        return variantData.find(function (variant) {
          if (!Array.isArray(variant.options)) return false;
          return variant.options.every(function (value, index) {
            return options[index] === undefined || options[index] === value;
          });
        });
      }

      function getSelectedCheckoutVariants() {
        ensureItemOptions();
        if (perBagColorMode()) {
          var bundleVariant = resolvePerBagBundleVariant();
          return bundleVariant ? [bundleVariant] : [];
        }
        var variants = [];
        var showSingleSkuSelector = checkoutOptions && checkoutOptions.getAttribute('data-xn-single-sku-selector') === 'true';
        var checkoutQuantity = getCheckoutQuantity();
        for (var index = 0; index < checkoutQuantity; index += 1) {
          var itemOptions = showSingleSkuSelector
            ? (selectedItemOptions[0] || selectedOptions)
            : (selectedItemOptions[index] || selectedOptions);
          var variant = findVariantByOptions(itemOptions);
          if (!variant || variant.available === false) return [];
          variants.push(variant);
        }
        return variants;
      }

      function updateCheckoutBuyState() {
        if (!checkoutOptions) return;
        var checkoutVariants = getSelectedCheckoutVariants();
        section.querySelectorAll('.xn-product__buy-button').forEach(function (button) {
          button.disabled = checkoutVariants.length !== getCheckoutQuantity();
        });
      }

      function setVariantFromOption(position, value, fallbackVariantId, itemIndex) {
        ensureItemOptions();
        var scopedItemIndex = Number(itemIndex) || 0;
        if (perBagColorMode() && position === 0) {
          selectedItemOptions[scopedItemIndex] = selectedItemOptions[scopedItemIndex] || selectedOptions.slice();
          selectedItemOptions[scopedItemIndex][0] = value;
          var perBagVariant = resolvePerBagBundleVariant();
          updateCheckoutBuyState();
          return perBagVariant;
        }
        var nextOptions = (selectedItemOptions[scopedItemIndex] || selectedOptions).slice();
        nextOptions[position] = value;
        var variant = findVariantByOptions(nextOptions);
        if (!variant && fallbackVariantId) variant = findVariantById(fallbackVariantId);
        if (variant) {
          selectedItemOptions[scopedItemIndex] = variant.options.slice();
          if (scopedItemIndex === 0) {
            setVariantSelection(variant);
          } else {
            updateCheckoutOptionUi();
            updateCheckoutBuyState();
          }
        }
        return variant;
      }

      if (variantInput) {
        var initialVariant = findVariantById(variantInput.value);
        if (initialVariant) {
          setVariantSelection(initialVariant);
          if (packagesAreVariants()) {
            var defaultPackageButton = checkoutOptions.querySelector('[data-xn-checkout-package-list] [data-package-count="' + selectedPackageCount + '"]');
            setVariantFromPackage(defaultPackageButton);
          }
        }
      }

      section.querySelectorAll('[data-xn-checkout-package-list] [data-package-count]').forEach(function (button) {
        button.addEventListener('click', function () {
          var variantId = button.getAttribute('data-variant-id');
          var packageCount = button.getAttribute('data-package-count');
          if (packageCount) setActivePackageCount(packageCount);
          if (setVariantFromPackage(button)) {
            return;
          }
          var variant = findVariantById(variantId);
          if (!variant) {
            if (button.parentElement) {
              button.parentElement.querySelectorAll('.xn-product__package').forEach(function (packageButton) {
                packageButton.classList.remove('is-active');
              });
            }
            button.classList.add('is-active');
            if (variantId && variantInput) variantInput.value = variantId;
            return;
          }
          setVariantSelection(variant);
        });
      });

      section.querySelectorAll('[data-xn-checkout-options] .xn-product__checkout-value[data-option-position]').forEach(function (button) {
        button.addEventListener('click', function () {
          var position = Number(button.getAttribute('data-option-position')) || 0;
          var itemIndex = Number(button.getAttribute('data-item-index')) || 0;
          setVariantFromOption(position, button.getAttribute('data-option-value'), null, itemIndex);
        });
      });

      var productForm = section.querySelector('.xn-product__form');
      if (productForm && checkoutOptions) {
        productForm.addEventListener('submit', function (event) {
          // Always take over the submit so the browser never performs the native
          // POST to /cart/add (which would land the shopper on the /cart page).
          event.preventDefault();
          var checkoutVariants = getSelectedCheckoutVariants();
          if (!checkoutVariants.length) {
            // Fallback: if the per-item option matching produced nothing (can
            // happen on some devices), use the currently selected variant from the
            // hidden input so the buy button always proceeds to checkout instead of
            // silently doing nothing.
            var fallbackVariant = variantInput ? findVariantById(variantInput.value) : null;
            if (!fallbackVariant && variantData.length) fallbackVariant = variantData[0];
            if (fallbackVariant) {
              var fallbackCount = Math.min(Math.max(getCheckoutQuantity(), 1), 4);
              checkoutVariants = [];
              for (var fi = 0; fi < fallbackCount; fi += 1) checkoutVariants.push(fallbackVariant);
            }
          }
          if (!checkoutVariants.length) return;
          var submitButton = productForm.querySelector('.xn-product__buy-button');
          if (submitButton) submitButton.disabled = true;

          fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' }
          })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: checkoutVariants.map(function (variant, index) {
                    return {
                      id: variant.id,
                      quantity: 1,
                      properties: {
                        '_bundle_item': String(index + 1),
                        '_bundle_count': String(getCheckoutQuantity())
                      }
                    };
                  })
                })
              });
            })
            .then(function (response) {
              if (!response.ok) throw new Error('Cart add failed');
              var claimedExitCoupon = getClaimedExitCoupon();
              var checkoutDiscountCode = claimedExitCoupon || selectedDiscountCode;
              window.location.href = checkoutDiscountCode ? '/checkout?discount=' + encodeURIComponent(checkoutDiscountCode) : '/checkout';
            })
            .catch(function () {
              // Re-enable so the shopper can retry. Never fall back to the native
              // form submit — that would navigate to the /cart page.
              if (submitButton) submitButton.disabled = false;
              var claimedExitCoupon = getClaimedExitCoupon();
              if (claimedExitCoupon) {
                window.location.href = '/checkout?discount=' + encodeURIComponent(claimedExitCoupon);
              }
            });
        });
      }

      var reviewCards = Array.prototype.slice.call(section.querySelectorAll('[data-xn-review-card]'));
      var reviewPageButtons = Array.prototype.slice.call(section.querySelectorAll('[data-xn-review-page]'));
      var reviewPrev = section.querySelector('[data-xn-review-prev]');
      var reviewNext = section.querySelector('[data-xn-review-next]');
      var reviewsPerPage = 5;
      var currentReviewPage = 1;
      var pendingTabTarget = null;
      var pendingTabTop = null;
      var pendingTabWatch = null;

      function setReviewPage(page) {
        if (!reviewCards.length) return;
        var totalPages = Math.max(Math.ceil(reviewCards.length / reviewsPerPage), 1);
        currentReviewPage = Math.min(Math.max(page, 1), totalPages);
        reviewCards.forEach(function (card, index) {
          var cardPage = Math.floor(index / reviewsPerPage) + 1;
          card.classList.toggle('is-visible', cardPage === currentReviewPage);
        });
        reviewPageButtons.forEach(function (button) {
          button.classList.toggle('is-current', Number(button.getAttribute('data-xn-review-page')) === currentReviewPage);
        });
        if (reviewPrev) {
          reviewPrev.disabled = currentReviewPage === 1;
          reviewPrev.classList.toggle('is-muted', currentReviewPage === 1);
        }
        if (reviewNext) {
          reviewNext.disabled = currentReviewPage === totalPages;
          reviewNext.classList.toggle('is-muted', currentReviewPage === totalPages);
        }
      }

      reviewPageButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setReviewPage(Number(button.getAttribute('data-xn-review-page')) || 1);
        });
      });
      if (reviewPrev) {
        reviewPrev.addEventListener('click', function () {
          setReviewPage(currentReviewPage - 1);
        });
      }
      if (reviewNext) {
        reviewNext.addEventListener('click', function () {
          setReviewPage(currentReviewPage + 1);
        });
      }
      setReviewPage(1);

      function setActiveTab(target) {
        var tabs = section.querySelector('[data-xn-tabs]');
        if (tabs) tabs.classList.toggle('is-reviews-active', target === 'reviews');
        section.querySelectorAll('[data-xn-tab]').forEach(function (tabButton) {
          tabButton.classList.toggle('is-active', tabButton.getAttribute('data-xn-tab') === target);
        });
      }

      function stopPendingTabWatch() {
        if (pendingTabWatch) window.clearInterval(pendingTabWatch);
        pendingTabWatch = null;
        pendingTabTarget = null;
        pendingTabTop = null;
      }

      function watchPendingTabTarget() {
        if (!pendingTabTarget || pendingTabTop === null) return;
        setActiveTab(pendingTabTarget);
        if (Math.abs(window.scrollY - pendingTabTop) < 8) {
          stopPendingTabWatch();
          updateActiveTabFromScroll();
        }
      }

      function scrollToProductArea(target) {
        var targetPanel = section.querySelector('[data-xn-scroll-target="' + target + '"]');
        if (!targetPanel) return;
        var tabs = section.querySelector('[data-xn-tabs]');
        var offset = tabs ? tabs.getBoundingClientRect().height : 0;
        var top = targetPanel.getBoundingClientRect().top + window.scrollY - offset - 2;
        pendingTabTop = Math.max(top, 0);
        window.scrollTo({ top: pendingTabTop, behavior: 'smooth' });
      }

      function updateActiveTabFromScroll() {
        var reviewsPanel = section.querySelector('[data-xn-scroll-target="reviews"]');
        var tabs = section.querySelector('[data-xn-tabs]');
        if (!reviewsPanel || !tabs) return;
        if (pendingTabTarget) {
          setActiveTab(pendingTabTarget);
          return;
        }
        var threshold = Math.max(tabs.getBoundingClientRect().height + 12, window.innerHeight * 0.35);
        var isAtPageBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
        setActiveTab(reviewsPanel.getBoundingClientRect().top <= threshold || isAtPageBottom ? 'reviews' : 'details');
      }

      window.addEventListener('scroll', updateActiveTabFromScroll, { passive: true });
      window.addEventListener('resize', updateActiveTabFromScroll);
      updateActiveTabFromScroll();

      section.querySelectorAll('[data-xn-tab]').forEach(function (button) {
        button.addEventListener('click', function () {
          var target = button.getAttribute('data-xn-tab');
          pendingTabTarget = target;
          if (pendingTabWatch) window.clearInterval(pendingTabWatch);
          setActiveTab(target);
          scrollToProductArea(target);
          pendingTabWatch = window.setInterval(watchPendingTabTarget, 100);
          window.setTimeout(stopPendingTabWatch, 2600);
        });
      });
    }

    function initXnProducts(root) {
      var scope = root || document;
      var sections = scope.matches && scope.matches('.xn-product[data-section-id]')
        ? [scope]
        : scope.querySelectorAll('.xn-product[data-section-id]');
      Array.prototype.forEach.call(sections, initXnProduct);
    }

    initXnProducts(document);

    document.addEventListener('shopify:section:load', function (event) {
      initXnProducts(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
